@if (bookingAvailabilities.length > 0) {
  <div class="availability-wrapper" [ngClass]="{ 'align-self-end': (inputMessage() | messageStatusType) === 'sent' }">
    <ng-container *ngFor="let availability of bookingAvailabilities">
      <button mat-flat-button (click)="setPreferredBooking(availability)">
        {{ availability.displayText }}
      </button>
    </ng-container>
  </div>
}
